import RbataCookieUtils from './rbata.cookie-utils';
import urlService from '../services/rbata.urlService';
import RbataLogger from './rbata.logger';
import {productRecommendations} from '../components/rbata.productRecommendation';

export const Bloomreach = {
    cookieName:          '__exponea_etc__',
    brSite:              undefined,
    isLoaded:            false,
    isReady:             false,
    optanonConsentGiven: alphatauri.cookie.optanonConsentGiven,
    considerConsent:     alphatauri.cookie.considerConsent,

    bloom() {
        this.isLoaded = !!window.exponea;
        this.brSite = RbataCookieUtils.readCookie(this.cookieName);
        this.isReady = this.isLoaded && this.brSite && (this.considerConsent === false || this.optanonConsentGiven);

        if (this.isReady) {
            // Callback when BR is ready
            productRecommendations.init();
            productRecommendations.load();
        }
    },

    fetch(options) {
        if (this.isReady) {
            window.exponea?.getRecommendation(options);
        } else {
            RbataLogger.debug('Bloomreach not ready!');
        }
    },

    fetchPersonalizedProducts(initialOptions, items, callback) {
        let options = {
            ...initialOptions,
            catalogFilter:              initialOptions.catalogFilter === 'false' ? [] : initialOptions.catalogFilter,
            fillWithRandom:             initialOptions.fillWithRandom === 'true',
            catalogAttributesWhitelist: ['product_id'],
            callback,
            items
        };
        RbataLogger.debug("Recommendation options: ", options)
        this.fetch(options);
    },

    // Hybris product enrichment
    getRecommendationsUrl(componentId, recommendedProducts) {
        return `${urlService.getBaseUrl()}bloomreachcarouselcomponent/recommendedproducts?carouselId=${componentId}&productCodes=${recommendedProducts}`
    },

    // Hybris product enrichment
    getCrossSellingUrl(componentId, recommendedProducts) {
        return `${urlService.getBaseUrl()}bloomreachcarouselcomponent/crossselling?carouselId=${componentId}&productCodes=${recommendedProducts}`
    }
}

$(() => {
    Bloomreach.bloom();
});